$(function(){
    $('input[name="type"]').change(function(){
        let value = $(this).val();
        let toggle = (['formacio', 'informacio', 'epis'].indexOf(value) === -1);
        $('#period').toggle(toggle);
        $('#period').find('input').prop('disabled', ! toggle);
    });
});

